import React from "react";

import Header from "../layout/Header";
import "./index.scss";
import AppButton from "../appButton";
import image from "../../assets/imageProfil.png";
import { useNavigate } from "react-router-dom";
const SlideHome = () => {
    const navigate = useNavigate();
  return (
    <div className="slide-home">
      <Header />
      <div className="slide-home-container ">
        <div className="row w-100">
          <div className="col-lg-5">
            <div className="slide-home-container-content ">
              <h1 className="slide-home-container-content-title">
                Unissons nos forces
              </h1>
              <p className="slide-home-container-content-description">
                La Fondation Junior MBUYI améliore les conditions de vie en
                milieu rural en fournissant vivres et infrastructures. Elle
                redonne espoir, dignité et autonomie aux populations souvent
                oubliées.
              </p>
              <AppButton
                text="FAIRE UN DON MAINTENANT"
                color="orange"
                size="large"
                onClick={() => {
                  navigate("/faire-don");    window.scrollTo(0, 0);
                }}
              />
            </div>
          </div>
          <div className="col-lg-7">
            {" "}
            <div className="slide-home-card">
              <div className="card">
                <div className=" card-title ">
                  <div className="profile-image">
                    <img src={image} alt={`profile`} />
                  </div>
                  <div className="profile-info">
                    <h3>Junior Mubuyi</h3>
                    <p>Fondateur</p>
                  </div>
                </div>
                <p className="card-description">
                  Junior Mbuyi est un entrepreneur qui imprime sa marque dans le
                  secteur du conseil financier. Son cabinet opère activement
                  dans le conseil bancaire, accompagnant des institutions
                  financières internationales et contribuant à la mise en place
                  de réformes réglementaires d'ampleur.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
    </div>
  );
};

export default SlideHome;
